import * as types from '../actions/actionTypes'; 
import initialState from './initialState';

export default function (state = initialState.user, action) {
  switch(action.type) {
    case types.DO_OFFERING_CALLBACKS_RES:
      return action.data
    default:
      return state
  }
}
